import { axios } from '@/utils/request'

// 添加申请
export function post(data) {
  return axios({
    url: '/distribution/applicationForm',
    method: 'POST',
    data
  })
}

// 查看状态
export function get() {
  return axios({
    url: '/distribution/applicationForm',
    method: 'GET'
  })
}

// 数据概览
export function getDataPreview() {
  return axios({
    url: '/distribution/payCommission',
    method: 'GET'
  })
}

// 订单明细
export function getOrderDetails(params) {
  return axios({
    url: '/distribution/payCommission/orderDetails',
    method: 'GET',
    params
  })
}

// 客户列表

export function getCustomerList(params) {
  return axios({
    url: '/distribution/payCommission/customerList',
    method: 'GET',
    params
  })
}

// 账单

export function getBill(params) {
  return axios({
    url: '/distribution/payCommission/bill',
    method: 'GET',
    params
  })
}

// 获取名下用户

export function getPromotedAccounts() {
  return axios({
    url: '/distribution/user/getPromotedAccounts',
    method: 'GET'
  })
}

// 获取余额

export function getBalance() {
  return axios({
    url: '/distribution/group',
    method: 'GET'
  })
}

// 提现金

export function withdrawCash(data) {
  return axios({
    url: '/distribution/payWithdrawalApplication',
    method: 'POST',
    data
  })
}
